import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import type { PlatformBlockComponent } from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";
import { TextField } from "@/shared/components/Form/TextField";
import { AutocompleteField } from "@/shared/components/Form/AutocompleteField";
import { Switch } from "@/shared/components/Form/Switch";
import { ItemsPerRowField } from "../../ItemsPerRowField";

const viewValues = ["CAROUSEL", "GRID"] as const;

const typeValues = ["PPV", "SUBSCRIPTION"] as const;

// Форма настроек блока PRODUCTS (site: ProductsBlock, порт референсного
// ArenaProducts.js) — по образцу блока CONTENTS (Contents.tsx):
// title/limit/type/view/loadMore/moreUrlHref. Без rightholderIds (нет
// такого фильтра в site-схеме Task 4) и без productTypeIds/
// autocompleteProductTypes — эта форма ранее ссылалась на несуществующую
// сущность "тип товара" (отдельный каталог типов), которой нет ни в
// backend-схеме Product (type: PPV|SUBSCRIPTION — enum, не entity), ни в
// queries конструктора; заменено простым select'ом по ProductType.
export const Products: PlatformBlockComponent = ({ name, values }) => {
  const { t } = useTranslation();

  const viewOptions = viewValues.map((value) => ({
    value,
    label: t(`platformBlocks.view.${value}`),
  }));

  const typeOptions = typeValues.map((value) => ({
    value,
    label: t(`platformBlocks.productType.${value}`),
  }));

  const props = values?.props as Record<string, unknown> | undefined;

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="PRODUCTS" props={props} />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.title`}
            label={t("platformBlocks.fields.title")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <AutocompleteField
            name={`${name}.view`}
            label={t("platformBlocks.fields.view")}
            fullWidth
            options={viewOptions}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <AutocompleteField
            name={`${name}.type`}
            label={t("platformBlocks.fields.productType")}
            fullWidth
            options={typeOptions}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <ItemsPerRowField
            name={`${name}.itemsPerRow`}
            label={t("platformBlocks.fields.itemsPerRow")}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            name={`${name}.limit`}
            label={t("platformBlocks.fields.limit")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            name={`${name}.moreUrlHref`}
            label={t("platformBlocks.fields.moreUrl")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            name={`${name}.moreText`}
            label={t("platformBlocks.fields.moreText")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid>
          <Switch
            name={`${name}.loadMore`}
            label={t("platformBlocks.fields.loadMoreOnScroll")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
